import {
  capitalize,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../../routes/paths';
import MenuPopover from '../../../components/menu-popover';
import Iconify from '../../../components/iconify';
import { useMemo, useState } from 'react';
import moment from 'moment';
import { getLatestDispenseTillLine } from './tillListShared';

function getLastTillActivityMs(till: any): number | null {
  let maxMs = 0;
  const consider = (value: string | null | undefined) => {
    if (!value) return;
    const ms = moment(value).valueOf();
    if (!Number.isNaN(ms) && ms > maxMs) maxMs = ms;
  };

  for (const dt of till.dispenseTills || []) {
    consider(dt.paymentDate);
    consider(dt.refundedAt);
    for (const p of dt.payments || []) {
      consider(p.date);
    }
  }

  consider(till.updatedDate);
  consider(till.createdDate);
  consider(till.updated_at);
  consider(till.created_at);

  return maxMs > 0 ? maxMs : null;
}

type Props = {
  till: any;
};

export default function TillTableRow({ till }: Props) {
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const lastTillLabel = useMemo(() => {
    const ms = getLastTillActivityMs(till);
    return ms != null ? moment(ms).format('DD/MM/YYYY HH:mm') : '—';
  }, [till]);

  const latestStatusLabel = useMemo(() => {
    const raw = getLatestDispenseTillLine(till)?.status;
    return raw ? capitalize(raw) : 'N/A';
  }, [till]);

  const handleViewTill = () => {
    navigate(PATH_DASHBOARD.till.detail(till.id), {
      state: { patientData: till },
    });
  };

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <TableRow hover>
        <TableCell
          style={{ cursor: 'pointer' }}
          align="center"
          onClick={handleViewTill}
        >
          <Typography variant="subtitle2" noWrap>
            {[till.patient.title, till.patient.firstName, till.patient.surName]
              .filter(Boolean)
              .join(' ')}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography
            variant="subtitle2"
            style={{ cursor: 'pointer' }}
            noWrap
            onClick={handleViewTill}
          >
            {till.id}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {till?.dispenseTills?.length ? till?.dispenseTills?.length : 0}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {lastTillLabel}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="subtitle2" noWrap>
            {latestStatusLabel}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <IconButton
            color={openPopover ? 'inherit' : 'default'}
            onClick={handleOpenPopover}
          >
            <Iconify icon="eva:more-horizontal-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        arrow="right-top"
        sx={{ width: 160 }}
      >
        <MenuItem
          onClick={() => {
            handleViewTill();
            handleClosePopover();
          }}
        >
          <Iconify icon="eva:eye-fill" />
          View
        </MenuItem>
      </MenuPopover>
    </>
  );
}
